

















































import { Component, Vue } from 'vue-property-decorator';
import { BModal } from 'bootstrap-vue';

@Component
export default class CommentModal extends Vue {
  comment = '';
  shouldEmit = false; // flag to controll emission

  get modal(): BModal {
    return this.$refs.commentModal as BModal;
  }

  show(initialText = '') {
    this.comment = initialText;
    this.shouldEmit = false; // reset flag
    this.modal.show();
  }

  onSave() {
    this.comment = this.comment.trim();
    
    if (this.isMeaningless(this.comment)) {
      this.comment = ''; 
      this.makeToast(
        'warning', 
        'Cначала введите текст примечания', 
        'Внимание!', 
        3000
      );
      return;
    }

    this.shouldEmit = true; 
    this.$emit('save', this.comment);
    this.closeModal();
  }

  onSaveWithoutComment() {
    this.shouldEmit = true; // Mark that we should emit
    this.$emit('saveNoComment');
    this.closeModal();
  }

  closeModal() {
    this.comment = ''; 
    this.modal.hide(); // triggers @hidden event
  }


  onClear() {
    this.comment = ''; 
    return; 
  }

  onModalHidden() {
    // Only emit if user closed modal without clicking any button
    this.shouldEmit = false;
    this.comment = '';
  }

  isMeaningless(str: string) {
    return !str || !str.replace(/[^\p{L}\p{N}]/gu, '')
  };

  makeToast(variant: string, tostbody: string, title: string, autoHideDelay?: number): void {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            autoHideDelay: autoHideDelay,
            solid: true
        });
    }
}
